import { useState } from "react";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function useTeams() {
  const { api, bearerApi, AdminId } = useGlobalContext();

  const [loading, setLoading] = useState(false);

  const shouldShowLocalError = (data) => {
    return (
      data?.responseCode !== "00" &&
      data?.responseCode !== "02" &&
      data?.responseCode !== "03" &&
      data?.responseCode !== "98" &&
      data?.responseCode !== "401"
    );
  };

  // CREATE TEAM
  // Original API used Basic token, so use api
  const createTeam = async (teamName, accuracy, onSuccess) => {
    if (!teamName || !accuracy) {
      toast.error("Please fill all fields");
      return false;
    }

    setLoading(true);

    try {
      const payload = {
        teamName,
        device: "web",
        userId: "9",
        accuracy,
        adminId: AdminId,
      };

      const res = await api.post("/api/Driver/v1.0/createDriverTeam", payload);

      if (res.data?.responseCode === "00") {
        toast.success(res.data?.responseMessage || "Team created successfully");

        if (typeof onSuccess === "function") {
          await onSuccess();
        }

        return true;
      }

      if (shouldShowLocalError(res.data)) {
        toast.error(res.data?.responseMessage || "Unable to create team");
      }

      return false;
    } catch (error) {
      console.error("createTeam error:", error);
      toast.error("Error creating team");
      return false;
    } finally {
      setLoading(false);
    }
  };

  // ASSIGN SHOP TO TEAM
  // Original API used Bearer token, so use bearerApi
 const assignShopToTeam = async ({ shopCode, teamId, onSuccess }) => {
   if (!shopCode || !teamId) {
     toast.error("Shop code and team are required");
     return false;
   }

   setLoading(true);

   try {
    const res = await bearerApi.post("/api/Driver/v1.0/assignTeamToShop", {
      shopCode: String(shopCode),
      teamId: String(teamId),
      adminId: String(AdminId),
    });

     if (res.data?.responseCode === "00") {
       toast.success(res.data?.responseMessage || "Team assigned successfully");

       if (typeof onSuccess === "function") {
         await onSuccess();
       }

       return true;
     }

     if (shouldShowLocalError(res.data)) {
       toast.error(res.data?.responseMessage || "Failed to assign shop");
     }

     return false;
   } catch (error) {
     console.error("assignShopToTeam error:", error);
     toast.error("Error assigning shop");
     return false;
   } finally {
     setLoading(false);
   }
 };

  return {
    loading,
    createTeam,
    assignShopToTeam,
  };
}